/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * profile-service.ts  2026-08-26T09:15:21+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { MiniTech, Petition } from './wy-dto'

const _ = 'Profile/'

export class ProfileService {
  constructor(readonly r: RpcService) {}
  // 最近购买过的产品编码,组合套餐情况下，也返回主套餐；如 zhongshi; 没有的情况下返回空字符串
  latestPurchased(m?: M): R<string> {
    return this.r.async(_ + 'latestPurchased', undefined, m)
  }
  // A/B testing 分桶，获取我被分配到的桶，默认0代表老桶，1代表新桶。上传友盟的时候做为标签上传
  myBucket(m?: M): R<number> {
    return this.r.async(_ + 'myBucket', undefined, m)
  }
  // 当天请愿,技师没开时间的可请求
  myPetition(d: string, m?: M): R<Petition> {
    return this.r.async(_ + 'myPetition', d, m)
  }
  // 已领取的券id
  myTickets(d: string, m?: M): R<Array<number>> {
    return this.r.async(_ + 'myTickets', d, m)
  }
  // 成功请愿,可预约的技师列表；限当天
  succPetition(m?: M): R<Array<MiniTech>> {
    return this.r.async(_ + 'succPetition', undefined, m)
  }
}
